import { Switch } from "@xola/ui-kit";
import React from "react";
import { Merchandise, MerchandiseFulfillmentStatus } from "types";
import { NoTranslate } from "../Common/NoTranslate";
import { ProductImage } from "../Common/ProductImage";
import { CreatePurchaseMerchandiseVariantPicker } from "./CreatePurchaseMerchandiseVariantPicker";
import { useCreatePurchaseStore } from "@/stores/createPurchaseStore";

interface CreatePurchaseMerchandiseFieldsProps {
    merchandise: Merchandise;
}

export const CreatePurchaseMerchandiseFields = ({ merchandise }: CreatePurchaseMerchandiseFieldsProps) => {
    const fulfillmentStatus = useCreatePurchaseStore((state) => state.getActiveItem().fulfillmentStatus);
    const setPurchase = useCreatePurchaseStore((state) => state.actions.setPurchase);
    const activeItemIndex = useCreatePurchaseStore((state) => state.activeItemIndex);

    const isAutoFulfill = fulfillmentStatus === MerchandiseFulfillmentStatus.PROCESSING_FULFILLMENT;

    const handleAutoFulfillChange = (checked: boolean) => {
        setPurchase((draft) => {
            const activeItem = draft.items[activeItemIndex];
            if (activeItem) {
                activeItem.fulfillmentStatus = checked
                    ? MerchandiseFulfillmentStatus.PROCESSING_FULFILLMENT
                    : MerchandiseFulfillmentStatus.PENDING_FULFILLMENT;
            }
        });
    };

    return (
        <>
            <div className="space-y-3 pb-2">
                <div className="flex items-center space-x-1">
                    <ProductImage product={merchandise} size="small" className="mr-1" />
                    <NoTranslate as="h4" className="font-bold">
                        {merchandise.name}
                    </NoTranslate>
                </div>
            </div>

            <CreatePurchaseMerchandiseVariantPicker />

            <div className="pt-4">
                <Switch.Group>
                    <Switch isChecked={isAutoFulfill} onChange={handleAutoFulfillChange} />
                    <Switch.Label className="ml-2">
                        Automatically fulfill orders for this product at the time of purchase
                    </Switch.Label>
                </Switch.Group>
            </div>
        </>
    );
};
